var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimStateReturned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-249-325h1200v1675h-1200z",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#845ef7",
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.0000312 11.1430438c1.657323 0 2.9999813 1.1508262 2.9999813 2.5716586 0 1.4196323-1.3426583 2.5704585-2.9999813 2.5704585-.5519965 0-.9999937.3840088-.9999937.8580196 0 .4728108.4479972.8568195.9999937.8568195 2.7613161 0 4.9999688-1.9188437 4.9999688-4.2852976 0-2.3676539-2.2386527-4.28649764-4.9999688-4.28649764h-3.75464321l1.87332161-2.04004647c.3426646-.37200847.266665-.91202077-.1666656-1.20482744-.437216-.29189178-1.05095602-.22894226-1.40399123.14400328l-3.33331252 3.63008268c-.29952655.32113729-.28404486.79334249.03599977 1.09802499l3.33331253 3.2280735c.37629859.3556877.99483315.3871989 1.41332455.0720017.1975838-.1456599.3189984-.3586894.3351819-.5880981.0161836-.2294088-.0743204-.4545483-.2498491-.6215295l-2.06932046-2.0040456z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimStateReturned);
export default __webpack_public_path__ + "static/media/claim-state-returned.04910749d26f87827bf79cab8e78262b.svg";
export { ForwardRef as ReactComponent };